<template>
  <div class="d-flex align-items-center">
    <span>
      <b-button v-if="document_info.doc_type === 'file' && getFileHref" class="btn-skep mr-3 mb-2" @click.prevent="downloadFile(document_info.title, getFileHref, print_mode)">       
        <b-link class="custom-attach-businesscase" 
          :href="print_mode ? getFileHref : '#'"
          
          target="_blank">
          {{ lang !== 'ENG' ? document_info.title : document_info.translated?.title_e }}
          <span v-if="fileIcon === 'document'" class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 20 20">
              <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
              <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
            </svg>
          </span>
          <span v-else-if="fileIcon === 'image'" class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-image"
              viewBox="0 0 20 20">
              <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
              <path
                d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1z" />
            </svg>
          </span>
          <span v-else class="icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-file-earmark-text" viewBox="0 0 20 20">
              <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
              <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
            </svg>
          </span>
        </b-link>
      </b-button>


      <a
        v-else-if="document_info.doc_type === 'link'"
        class="btn-skep mr-3 mb-2 custom-attach-businesscase d-inline-flex align-items-center"
        :href="lang !== 'ENG' ? document_info.link : document_info.translated?.link"
        target="_blank"
      >
        {{ lang !== 'ENG' ? document_info.title : document_info.translated?.title_e }}
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-link-45deg ml-2 mt-2" viewBox="0 0 20 20">
          <path d="M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1 1 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4 4 0 0 1-.128-1.287z"/>
          <path d="M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243z"/>
        </svg>
      </a>

      <a
        v-else-if="document_info.doc_type === 'storyboard'"
        class="btn-skep mr-3 mb-2"
        :href="document_info.link"
        target="_blank"
      >
        <b-link class="custom-attach-businesscase">
          {{ document_info.title }}
          <b-icon icon="box-arrow-up-right" />
        </b-link>
      </a>
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { downloadFile } from '../../../util';
export default {
  name: 'DocumentSb',
  props: {
    document_id: { type: [String, Number], default: '' },
    document_info: {
      type: Object,
      default() {
        return {};
      },
    },
    print_mode: { type: Boolean, default: false },
  },
  computed: {
    ...mapState('report_list', ['lang']),
    fileIcon() {
      return this.getFileIcon(this.document_info.path);
    },
    getFileHref() {
      return this.lang !== 'ENG'
        ? this.$store.state.static_host + this.document_info.path
        : (this.document_info.translated?.path) ? this.$store.state.static_host + this.document_info?.translated?.path : '';
    },
  },
  methods: {
    downloadFile,
    getFileIcon(filePath) {
      if (filePath) {
        const ext = filePath.split('.').pop().toLowerCase();
        if (['pdf', 'json', 'docx', 'doc', 'hwp'].includes(ext)) return 'document';
        if (['jpg', 'jpeg', 'png', 'svg', 'gif'].includes(ext)) return 'image';
      }
      return 'link';
    },
    
  },
};
</script>

<style lang="scss" scoped>
.custom-attach-businesscase {
  color: inherit;
}

.custom-attach-businesscase:focus,
.custom-attach-businesscase:active,
.custom-attach-businesscase:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}
</style>
